import React, { useState } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Sidebar, MobileHeader } from './Sidebar';

export const DashboardLayout = ({ requireAdmin = false }) => {
  const { user, loading, isAdmin, isSubadmin } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="spinner" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // If requireAdmin is true, allow both admin and subadmin
  if (requireAdmin && !isAdmin && !isSubadmin) {
    return <Navigate to="/dashboard" replace />;
  }

  // If requireAdmin is false and user is admin or subadmin, redirect to admin panel
  if (!requireAdmin && (isAdmin || isSubadmin)) {
    return <Navigate to="/admin" replace />;
  }

  return (
    <div className="min-h-screen bg-background">
      <MobileHeader onMenuClick={() => setSidebarOpen(true)} />
      <div className="flex">
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        <main className="flex-1 min-h-screen lg:min-h-[calc(100vh)] overflow-x-hidden">
          <div className="p-4 md:p-6 lg:p-8 animate-fade-in">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
